export default __webpack_public_path__ + "static/media/section2_1.16ef34b1.svg";